import api from "./apiService";

export const getAcademeicDegree = () => api().get(`/academicDegreeMaster/`).then(response => response);


const services = {
    getAcademeicDegree
}

export default services;